export const Colors = {
  primary: 'var(--primary-color)',
  secondary: 'var(--secondary-color)',
  primaryColor: '#3F4059',
  primaryBlue: '#3de3e4',
  primaryPurple: '#5D3DED',
  secondaryPurple: '#6240FF',
  black40: 'rgba(0,0,0,.4)',
  blueGray: '#475464',
  blueGray2: '#485465',
  blueMist: "#8593A5",
  lightGray: '#A8BAC8',
  lightGray2: '#8492A6',
  mutedGray: '#8896A9',
  ultraLightGray: '#D5D8DF',
  ultraLightGray2: '#EFF2F7',
  ultraLightGray3: '#F6F6F6',
  successGreen: '#4fd5ae',
  orange: '#FA7733',
  yellow: '#FFBB48',
  mediumGray: '#657e94',
  red: '#FA3333',
  redSecondary: '#FC615F',
  cadetBlue: '#A9BBC9',
  secondaryGreen: '#2DCE9F',
  lightBg: '#F5F6FA',
  defaultBlue: '#3ED1D2',
  defaultRed: '#FA3333',
  white: "#FFFFFF",
  white2: "#F7F7F7",
  black: "#000000",
};